module.exports = __webpack_public_path__ + "static/media/matilde-impressed.5cc533ab.png";